<template>
  <v-dialog max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <span class="float-right mt-5" v-bind="attrs" v-on="on"
        >Recuperar acesso</span
      >
    </template>
    <template v-slot:default="dialog">
      <v-card>
        <v-card-title class="green lighten-4 primary--text font-weight-bold">Recuperar Acesso</v-card-title>
        <v-card-text>
          <div class="secondary--text pa-7" style="font-size: 1rem">
            Fique Tranquilo! Basta solicitar uma nova senha com seu
            gerente/encarregado para recuperar seu acesso.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text rounded @click="dialog.value = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {};
</script>

